export default "__VITE_ASSET__CPh0aYK6__"